



























































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import moment from "moment";
import { findWithAttr } from "@/store/store";
import { IStore, IFetchRequest, IFetchResult } from "../api/store.interface";
import { ICompany } from "@/features/companies/api/company.interface";
import {
  StoreEventBus,
  ADD_EDIT_STORE
} from "@/features/stores/api/store.event";

@Component({
  name: "storeDialog"
})
export default class StoreDialog extends Vue {
  @Getter("company/companies")
  companies: ICompany[];

  show: boolean = false;
  valid: boolean = false;
  loading: boolean = false;
  companyId: number = -1;
  store: IStore = {} as IStore;
  formattedDate: string = "";

  $refs: {
    form: any;
  };

  @Watch("store.startDate")
  onDateChange(value: any) {
    this.formattedDate = moment(this.store.startDate).format("MM/DD/YYYY");
  }

  mounted() {
    StoreEventBus.$on(ADD_EDIT_STORE, (payload: IStore) => {
      this.valid = true;
      this.show = true;
      if (
        payload.startDate &&
        payload.startDate.localeCompare("0001-01-01") == 0
      ) {
        payload.startDate = this.getToday();
      }
      if (payload.companyId != null) {
        this.companyId = payload.companyId;
      }
      this.store = payload;
      this.store.startDate = moment
        .utc(this.store.startDate)
        .format("YYYY-MM-DD");
    });
  }

  save(): void {
    if (this.$refs.form.validate()) {
      var self = this;
      this.loading = true;

      this.store.companyId = this.companyId;

      if (this.store.id == -1) {
        this.$store
          .dispatch("store/add", this.store)
          .then((response: IStore) => {
            self.show = false;
            self.store = {} as IStore;
            self.loading = false;
          })
          .catch(function(error: any) {});
      } else {
        this.$store
          .dispatch("store/update", this.store)
          .then((response: IStore) => {
            self.show = false;
            self.store = {} as IStore;
            self.loading = false;
          })
          .catch((error: any) => {});
      }
    }
  }

  getToday(): string {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; // January is 0!
    var yyyy = today.getFullYear();

    var ddString = dd.toString();
    var mmString = mm.toString();
    var yyyyString = yyyy.toString();
    var todayString = "";

    if (dd < 10) {
      ddString = "0" + dd.toString();
    }

    if (mm < 10) {
      mmString = "0" + mm;
    }

    todayString = yyyyString + "-" + mmString + "-" + ddString;
    return todayString;
  }
}
